// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lato_532bdd', '__Lato_Fallback_532bdd'","fontStyle":"normal"},"className":"__className_532bdd","variable":"__variable_532bdd"};